/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


( function($) {

	$.fn.pagination = function( options ) {
		var settings = $.extend( {
            nextPage: '.next-page',
			noItems: '.no-page-items',
			loader: '#PaginatedListLoader',
			item: '.ajax-item'
        }, options );

		var container = this;

		var methods = {
			init: function() {
				container.find( settings.nextPage ).click( function( event ) {
					event.preventDefault();

					methods.process();
				} );
			},
			process: function() {
				if( container.find( settings.noItems ).length > 0 || container.find( settings.nextPage ).length === 0 ) {
					return;
				}

				var filter = JSON.stringify( container.data() );

				$( settings.loader ).show();

				container.find( settings.nextPage ).hide();

				$.get( container.find( settings.nextPage ).attr( 'href' ) + '&filter=' + filter, null, function( response ) {
					$( settings.loader ).hide();

					container.find( settings.nextPage ).parent().remove();

					container.append( response );

					$( settings.item ).hide();

					$( settings.item ).fadeIn( function() {
						$( this ).removeClass( settings.item.replace( '.', '' ) );
					} );

					methods.init();
				} );
			}
		};

		methods.init();
	};

} )( jQuery );
